module.exports = __webpack_public_path__ + "pc/img/icon6.095f2526.png";